<template>
  <div>
    <p>Cette fonction vous permet d’envoyer par mail un lien de paiement avec un motif</p>

    <div class="row">
      <div class="col col-md-6">
        <label class="field_label">Indiquer l'adresse mail de la personne</label>
        <v-text-field v-model="request.email"></v-text-field>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-3">
        <label class="field_label">Montant sportif</label>
        <v-text-field v-model="request.montant_sportif" @update:modelValue="updateMontant" type="number" min="0"
          outlined append-inner-icon="mdi-currency-eur"></v-text-field>
      </div>
      <div class="col col-md-3">
        <label class="field_label">Montant options</label>
        <v-text-field v-model="request.montant_option" @update:modelValue="updateMontant" type="number" min="0" outlined
          append-inner-icon="mdi-currency-eur"></v-text-field>
      </div>
      <div class="col col-md-3">
        <label class="field_label">Montant total (2€ de frais seront automatiquement ajoutés)</label>
        <v-text-field v-model="request.total" disabled type="number" min="0" outlined
          append-inner-icon="mdi-currency-eur"></v-text-field>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-6">
        <label class="field_label">Motif</label>
        <v-textarea v-model="request.motif"></v-textarea>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <v-btn class="sm-fullwidth mt-2 inscription_btn" color="primary-dark" @click="send_request">Envoyer le lien de
          paiement</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin.service";
export default {
  props: ["item"],
  data() {
    return {
      request: {
        id_module: 0,
        id_commande: 0,
        uuid_commande: "",
        id_inscription: 0,
        email: "",
        montant_sportif: 0,
        montant_option: 0,
        total: 0,
        motif: "",
      },
    };
  },
  methods: {
    updateMontant() {
      this.request.total = parseFloat(this.request.montant_sportif) + parseFloat(this.request.montant_option) + 2;
    },
    async send_request() {

      let req = await AdminService.createPaymentRequest(this.request);
      if (req) {
        this.$emit("onCreate");
      }
    },
  },

  created() {
    if (this.item) {
      this.request.id_module = this.item.id_module;
      this.request.id_commande = this.item.id_commande;
      this.request.id_inscription = this.item.id;
      this.request.motif = this.item.nom + " " + this.item.prenom + ": Changement...";
    }
  },
};
</script>

<style lang="scss" scoped></style>